const config = {
  env: process.env.NODE_ENV,
  appEnv: process.env.REACT_APP_APP_ENV,
};

export default config;
